export const KEYDOWN_EVENT_KEY_MAP = {
  enter: 'Enter',
} as const
